module.exports = __webpack_public_path__ + "static/media/T-C_RCP.8bf3aa2c.pdf";